export const ru = {
    'default-header-description': 'Продукты внутренней рекламы',
    'default-title': 'Список продуктов',
    description: 'Описание списка продуктов (спросить у редакторов)',
    'error-text': 'Попробуйте обновить страницу',
    'error-title': 'Что-то пошло не так',
    loading: 'Загрузка...',
    'marketers-header-description': 'Управление продуктами внутренней рекламы',
    'marketers-title': 'Управление продуктами',
    title: 'Список продуктов'
};
